const user_list = {
  title: '受講生管理',
  title_coach: 'アートシフトコーチ管理',
  title_mentor: 'コーチ担当者管理',
  csv_upload: 'CSVアップロード',
  csv_template: 'CSVテンプレート',
  csv_export: 'データ出力',
  keyword_student: 'ユーザー名、メールアドレス入力',
  keyword_coach: 'コーチ名、メールアドレス入力',
  keyword_mentor: 'コーチ担当者名、メールアドレス入力',
  new: '新規追加',
  graduation_terms: '卒業期',
  plan: 'プラン名',
  course: 'コース',
  progress: '進捗状態',
  payment_status: '課金ステータス',
  payment_detail: "詳細",
  graduation_billing: '課金中',
  graduation_free_for_student: '受講生無料',
  graduation_free_for_coach: 'コーチ無料',
  subscription_payment_current: '継続中',
  subscription_payment_suspended: '一時停止',
  subscription_payment_canceled: '永遠停止',
  date: '----/--/--',
  full_name: '受講生名',
  full_name_coach: 'コーチ名',
  full_name_mentor: 'コーチ担当者名',
  updated_at: '作成日',
  created_at_mentor: '作成日',
  status_label: 'ステータス: ',
  progress_label: '進捗状態: ',
  status: 'ステータス',
  active: '有効',
  avatar: 'アバター',
  email: 'メールアドレス',
  phone: '電話番号',
  password: 'パスワード',
  password_confirm: '確認パスワード',
  mentor: 'コーチ名',
  kanji_name: '氏名（漢字）',
  first_name_kanji: '田中',
  last_name_kanji: '太郎',
  first_name: 'タナカ',
  last_name: 'タロウ',
  birth_date: '生年月日',
  gender: '性別',
  time_zone: 'タイムゾーン ',
  post_code: '郵便番号',
  address: '住所',
  message_off: 'ユーザーをオフ状態に切り替えると、システムにログインできなくなります。よろしいでしょうか。',
  message_on: 'ユーザーをオン状態に切り替えると、システムにログインできるようになります。よろしいでしょうか。',
  popup: {
    title: '確認',
    content: 'ユーザーをオンに切り替えると、システムにログインできるようになります。よろしいでしょうか。',
    checkbox_content: 'チェックを入れる場合即時再課金となります。\nチェックを入れない場合翌月から課金となります。',
    btn_cancel: 'いいえ',
    btn_ok: 'はい',
  },
  toast: {
    cannot_active_toggle: 'ご指定のコーチは、Univapayより課金アカウトんが永遠停止にされていましたため、オンに切り替えることができません。',
    export_csv_fail: 'ご指定のデータを出力できませんでした。',
    export_csv_success: 'ご指定のデータを出力しました。',
  },
  change_status_error: {
    resume_subscription_error: 'ご指定のユーザーに対して、Univapay課金アカウントは再開できませんため、オンに切り替えることができません。',
    active_change_failed: 'ご指定のコーチに課金できませんため、オンに切り替えることができません。',
    timeout: '現在この時間帯では料金の請求を行うことができません。Univapayから午前7時半以降に料金の請求を受け付けていますため、7時半以降再度お試しください。',
    inactive_have_plan_or_graduation_invalid: 'ご指定のコーチはプランや卒業期が存在しないため、公開にできません。',
    not_found_subscription: 'ご指定のコーチは、Univapayより課金アカウトんが永遠停止にされていましたため、オンに切り替えることができません。',
  }
};

export default user_list;
